export default __webpack_public_path__ + "static/media/catbears_angry@2x.381d557c.png";